<template>
  <button
    v-bind="attrs"
    v-on="on"
    type="button"
    class="d-flex align-center px-3"
    :style="{
      color: isActive ? '#3461FF' : '#222222',
      minWidth: '76px',
    }"
  >
    <v-icon size="18" :color="isActive ? '#3461FF' : '#222222'" class="mr-1">
      mdi-filter
    </v-icon>
    {{ label }}
  </button>
</template>

<script>
export default {
  props: {
    on: Object,
    attrs: Object,
    isActive: Boolean,
    label: {
      type: String,
      default: "필터",
    },
  },
};
</script>
<style scoped lang="scss"></style>
